/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

function AplicativoRedirect() {
  const router = useRouter();
  useEffect(() => {
    router.replace(`/canais-de-atendimento.html`);
  }, []);
  return <>{/*  */}</>;
}

export const config = {
  amp: false,
};

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default AplicativoRedirect;
